import { useJsApiLoader, GoogleMap, Autocomplete } from "@react-google-maps/api";
import { useRef, useState } from "react";
import { Marker } from "@react-google-maps/api";
const defaultCenter = { lat: 40.748817, lng: -73.985428 }; // Default to New York

function LocationSelector({
  onAddressSelect,
  showButton = true, // Default behavior: requires confirmation
  divStyles = 'relative my-8 w-full mx-auto max-w-full',
  inputStyles = 'w-full px-5 py-2 border border-gray-300 focus:outline-none focus:border-[#AF313D]',
}) {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDDq_Z5B-HLaZH9Wsans0cbSSZ28y3GkEs",
    libraries: ["places"],
  });

  const [tempAddress, setTempAddress] = useState("");
  const [selectedAddress, setSelectedAddress] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const autocompleteRef = useRef(null);

  const handlePlaceSelect = () => {
    const place = autocompleteRef.current.getPlace();
    if (place && place.formatted_address && place.geometry) {
      setTempAddress(place.formatted_address);
      setSelectedLocation({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });

      // If showButton is false, update immediately
      if (!showButton) {
        setSelectedAddress(place.formatted_address);
        if (onAddressSelect) {
          onAddressSelect(place.formatted_address);
        }
      }
    }
  };

  const handleConfirmSelection = (e) => {
    e.preventDefault()
    setSelectedAddress(tempAddress);
    if (onAddressSelect) {
      onAddressSelect(tempAddress);
    }
  };

  if (loadError) return <p>Error loading maps</p>;
  if (!isLoaded) return <p>Loading maps...</p>;

  return (
    <div className={`${divStyles}`}>
      <div className="flex flex-col w-[100%] mx-auto max-w-full justify-center items-center">
        <Autocomplete
          className="w-full justify-center items-center mx-auto flex"
          onLoad={(ref) => (autocompleteRef.current = ref)}
          onPlaceChanged={handlePlaceSelect}
        >
          <input
            type="text"
            placeholder="Enter your address"
            className={`${inputStyles}`}
            onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
          />
        </Autocomplete>

        {showButton && (
          <button
            onClick={handleConfirmSelection}
            disabled={!tempAddress}
            className="mt-4 px-5 py-2 bg-rose-700  text-white rounded-md disabled:bg-gray-400"
          >
            Add Location
          </button>
        )}

        {(selectedAddress || selectedLocation) && (
          <div className="mt-4 p-4 bg-gray-100 rounded-lg shadow w-full text-center">
            <p><strong>Selected Address:</strong> {selectedAddress || tempAddress}</p>
          </div>
        )}

{selectedLocation && (
  <div className="relative h-[300px] w-full mt-4 bg-gray-200 rounded-md">
    <GoogleMap
      center={selectedLocation}
      zoom={15}
      mapContainerStyle={{ width: "100%", height: "100%" }}
      options={{
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
      }}
    >
      <Marker position={selectedLocation} />
    </GoogleMap>
  </div>
)}

      </div>
    </div>
  );
}

export default LocationSelector;
